var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudDrizzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99936 14.8993C3.2564 14.1402 2.69593 13.222 2.3604 12.2142C2.02486 11.2064 1.92307 10.1355 2.06272 9.08256C2.20238 8.02962 2.57982 7.02226 3.16646 6.1368C3.7531 5.25133 4.53355 4.51098 5.44869 3.97182C6.36384 3.43265 7.38969 3.10882 8.44853 3.02484C9.50737 2.94087 10.5714 3.09895 11.5601 3.48712C12.5488 3.8753 13.4362 4.48337 14.1551 5.2653C14.874 6.04723 15.4055 6.9825 15.7094 8.00026H17.4994C18.4649 8.00015 19.4048 8.31059 20.1804 8.8857C20.9559 9.46082 21.5259 10.2701 21.8061 11.1941C22.0864 12.118 22.062 13.1076 21.7367 14.0166C21.4113 14.9257 20.8022 15.706 19.9994 16.2423M7.99936 19.0003V20.0003M7.99936 14.0003V15.0003M15.9994 19.0003V20.0003M15.9994 14.0003V15.0003M11.9994 21.0003V22.0003M11.9994 16.0003V17.0003",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDrizzle);
export default __webpack_public_path__ + "static/media/cloud-drizzle.04cfbfb87ddb624eb34ac7539df47876.svg";
export { ForwardRef as ReactComponent };